import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {css, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {flexAbsoluteCenter, mb, ph} from "@pg-design/helpers-css";
import {RoomsIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {OfferBoxBase} from "../../atoms/OfferBoxBase";
import {SearchFiltersRooms} from "../../search/components/filters/SearchFiltersRooms";
import {useHitSearchSubmit} from "../../search/hooks/use_hit_search_submit";
import {useSearchFormSubmit} from "../../search/hooks/use_search_form_submit";
import {ISearchFiltersFormValues} from "../../search/types/ISearchFiltersFormValues";
import {SearchFormValuesType} from "../../search/types/SearchFormValuesType";
import {hitGtmFilterRoomsInBox} from "../tracking/listing_box_events";

type IRoomsFilterValue = ISearchFiltersFormValues["rooms"];

export function RoomsFilterBox() {
    const theme = useTheme();
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues) as SearchFormValuesType;
    const searchFormRooms = useSelector((state: IRPStore) => state.search.formValues.rooms);
    const offerListLatestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);
    const [rooms, setRooms] = useState<IRoomsFilterValue>(searchFormRooms);
    const hitSearchSubmit = useHitSearchSubmit();

    const submitSearchForm = useSearchFormSubmit({
        multiRegionLink: rpAppLink.offer.multiList,
        latestQuery: offerListLatestQuery,
        listFriendlyLink: rpAppLink.offer.listFriendly,
        abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad,
        onSearchSubmit: (formValues) => {
            hitSearchSubmit(formValues);
        }
    });

    useEffect(() => {
        setRooms(searchFormRooms);
    }, [searchFormRooms]);

    const onChange = (fieldName: string, value: IRoomsFilterValue) => {
        setRooms(value);
    };

    const onSubmit = async () => {
        const newFormValues = {
            ...searchFormValues,
            rooms
        };

        await submitSearchForm(newFormValues);

        hitGtmFilterRoomsInBox();
    };

    return (
        <OfferBoxBase css={boxBase}>
            <RoomsIcon css={mb(2)} size="4.8" wrapperSize="4.8" wrapperColor={theme.colors.primary} />
            <Text css={mb(3)} as="p" variant="headline_5" align="center">
                Chcesz zobaczyć lepiej dopasowane oferty?
            </Text>
            <Text css={mb(3)} variant="body_copy_1">
                Dopasuj liczbę pokoi
            </Text>
            <div css={fullWidth}>
                <SearchFiltersRooms
                    css={mb(5)}
                    toggleDropdown={() => null}
                    clearField={() => null}
                    name="rooms"
                    value={rooms}
                    showFooter={false}
                    onChange={onChange}
                />
            </div>
            <Button css={fullWidth} variant="filled_primary" onClick={onSubmit}>
                Filtruj
            </Button>
        </OfferBoxBase>
    );
}

const boxBase = css`
    ${flexAbsoluteCenter};
    ${ph(2)};
    padding-top: 60px;
    padding-bottom: 60px;
`;

const fullWidth = css`
    width: 100%;
`;
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {css, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {flexAbsoluteCenter, mb, ph} from "@pg-design/helpers-css";
import {RoomsIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {OfferBoxBase} from "../../atoms/OfferBoxBase";
import {SearchFiltersRooms} from "../../search/components/filters/SearchFiltersRooms";
import {useHitSearchSubmit} from "../../search/hooks/use_hit_search_submit";
import {useSearchFormSubmit} from "../../search/hooks/use_search_form_submit";
import {ISearchFiltersFormValues} from "../../search/types/ISearchFiltersFormValues";
import {SearchFormValuesType} from "../../search/types/SearchFormValuesType";
import {hitGtmFilterRoomsInBox} from "../tracking/listing_box_events";

type IRoomsFilterValue = ISearchFiltersFormValues["rooms"];

export function RoomsFilterBox() {
    const theme = useTheme();
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues) as SearchFormValuesType;
    const searchFormRooms = useSelector((state: IRPStore) => state.search.formValues.rooms);
    const offerListLatestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);
    const [rooms, setRooms] = useState<IRoomsFilterValue>(searchFormRooms);
    const hitSearchSubmit = useHitSearchSubmit();

    const submitSearchForm = useSearchFormSubmit({
        multiRegionLink: rpAppLink.offer.multiList,
        latestQuery: offerListLatestQuery,
        listFriendlyLink: rpAppLink.offer.listFriendly,
        abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad,
        onSearchSubmit: (formValues) => {
            hitSearchSubmit(formValues);
        }
    });

    useEffect(() => {
        setRooms(searchFormRooms);
    }, [searchFormRooms]);

    const onChange = (fieldName: string, value: IRoomsFilterValue) => {
        setRooms(value);
    };

    const onSubmit = async () => {
        const newFormValues = {
            ...searchFormValues,
            rooms
        };

        await submitSearchForm(newFormValues);

        hitGtmFilterRoomsInBox();
    };

    return (
        <OfferBoxBase css={boxBase}>
            <RoomsIcon css={mb(2)} size="4.8" wrapperSize="4.8" wrapperColor={theme.colors.primary} />
            <Text css={mb(3)} as="p" variant="headline_5" align="center">
                Chcesz zobaczyć lepiej dopasowane oferty?
            </Text>
            <Text css={mb(3)} variant="body_copy_1">
                Dopasuj liczbę pokoi
            </Text>
            <div css={fullWidth}>
                <SearchFiltersRooms
                    css={mb(5)}
                    toggleDropdown={() => null}
                    clearField={() => null}
                    name="rooms"
                    value={rooms}
                    showFooter={false}
                    onChange={onChange}
                />
            </div>
            <Button css={fullWidth} variant="filled_primary" onClick={onSubmit}>
                Filtruj
            </Button>
        </OfferBoxBase>
    );
}

const boxBase = css`
    ${flexAbsoluteCenter};
    ${ph(2)};
    padding-top: 60px;
    padding-bottom: 60px;
`;

const fullWidth = css`
    width: 100%;
`;
